import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const SignUpNudgeQuickViewState = mediatorAtom({ isOpen: false });

export default function useSignUpNudgeQuickView() {
    return useMediatorState(SignUpNudgeQuickViewState);
}
